module.exports = __webpack_public_path__ + "static/media/NotasFiscais6.2a40c8fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancNotasFiscais/NotasFiscais6.png
// module id = 2136
// module chunks = 0